export default "__VITE_ASSET__BIOBJC5N__"